import { Route, Routes } from "react-router";
import { useRemoteConfig } from "./core/services/firebase.service";
import Agreement from "./pages/Agreement/Agreement";
import Contact from "./pages/Contact/Contact";
import FAQ from "./pages/FAQ/FAQ";
import Home from "./pages/Home/Home";

const App = () => {
  const { isLoading } = useRemoteConfig();

  if (isLoading) {
    return (
      <div className="app-loading">
        <div className="loading-spinner" />
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/agreement" element={<Agreement />} />
      {/* <Route path="/journey" element={<JourneyPage />} /> */}
    </Routes>
  );
};

export default App;
